module.exports = __webpack_public_path__ + "assets/images/pages/ministerioconsumo/grid-5.png?6ec485be";